import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  interval,
  map,
  of,
  shareReplay,
  skipUntil,
  startWith,
  Subject,
  switchMap,
} from 'rxjs';
import { OiqNotificationEventsService } from './events.service';

@Injectable({
  providedIn: 'root',
})
export class OiqNotificationEventsStore {
  constructor(private service: OiqNotificationEventsService) {}

  reload$ = new Subject<void>();

  events$ = this.reload$.pipe(
    switchMap(() => this.service.eventsList('false')),
    catchError(() => of({ rows: [], total: 0 })),
    shareReplay()
  );
  eventsRows$ = this.events$.pipe(map(({ rows }) => rows));
  eventsTotal$ = this.events$.pipe(map(({ total }) => total));

  unreadEvents$ = this.reload$.pipe(
    switchMap(() => this.service.eventsList('true')),
    catchError(() => of({ rows: [], total: 0 })),
    shareReplay()
  );
  unreadEventsRows$ = this.unreadEvents$.pipe(map(({ rows }) => rows));
  unreadEventsTotal$ = this.unreadEvents$.pipe(map(({ total }) => total));

  pastEvents$ = this.reload$.pipe(
    switchMap(() => this.service.pastEventsList('true', 'false')),
    catchError(() => of({ rows: [], total: 0 })),
    shareReplay()
  );
  pastEventsRows$ = this.pastEvents$.pipe(map(({ rows }) => rows));
  pastEventsTotal$ = this.pastEvents$.pipe(map(({ total }) => total));

  upcomingEvents$ = this.reload$.pipe(
    switchMap(() => this.service.upcomingEventsList('true', 'false')),
    catchError(() => of({ rows: [], total: 0 })),
    shareReplay()
  );
  upcomingEventsRows$ = this.upcomingEvents$.pipe(map(({ rows }) => rows));
  upcomingEventsTotal$ = this.upcomingEvents$.pipe(map(({ total }) => total));

  futureEvents$ = this.reload$.pipe(
    switchMap(() => this.service.futureEventsList('true', 'false')),
    catchError(() => of({ rows: [], total: 0 })),
    shareReplay()
  );
  futureEventsRows$ = this.futureEvents$.pipe(map(({ rows }) => rows));
  futureEventsTotal$ = this.futureEvents$.pipe(map(({ total }) => total));

  /**
   * Updates section
   */
  intervalEnabled$ = new BehaviorSubject<boolean>(false);
  interval$ = interval(5 * 60 * 1000).pipe(
    startWith(0),
    skipUntil(this.intervalEnabled$.pipe(map(_isEnabled => !_isEnabled)))
  );
  updates$ = this.interval$.pipe(
    switchMap(() => this.service.getNotifications('true')),
    shareReplay()
  );

  updatesUpcomingEvents$ = this.updates$.pipe(
    switchMap(r =>
      r['upcoming-events'] > 0 ? this.service.upcomingEventsList('true', 'true') : of({ rows: [] })
    ),
    map(r => r.rows || []),
    catchError(err => of([])),
    shareReplay()
  );
}
